import React from 'react';

import {BulkActionFooter} from 'src/components/bulk-tool/bulk-action-footer';

import Button from '@pb/kit-component-button';
import {DialogHeader, DialogMain} from '@pb/kit-component-dialog-v2';
import {Group} from '@pb/kit-component-group';
import {pluralize} from '@pb/kit-formatters';

import {DEVICE_REGISTRATION_MODAL_TITLES} from '../constants';

import type {ProcessBulkAction} from 'src/components/bulk-tool/typedef';
import type {ActionOptions} from 'src/components/save-with-reason/action-with-reason-button';
import type {UsersBrowserRegistration} from 'src/openapi/admin/models/UsersBrowserRegistration';

type Props = {
    userIds: number[],
    onCloseModal: (submit: boolean) => void,
    processAction: ProcessBulkAction<UsersBrowserRegistration>,
    updateStatus: boolean,
};

const MODAL_WIDTH = 500;

export const UpdateDeviceRegistrationSettingsModal = ({userIds, onCloseModal, processAction, updateStatus}: Props) => {
    const caption = updateStatus
        ? DEVICE_REGISTRATION_MODAL_TITLES.ENABLE_DEVICE_REGISTRATION
        : DEVICE_REGISTRATION_MODAL_TITLES.DISABLE_DEVICE_REGISTRATION;
    return (
        <>
            <DialogHeader onClose={() => onCloseModal(false)}>
                {caption}
            </DialogHeader>
            <DialogMain style={{padding: 24, maxWidth: MODAL_WIDTH}}>
                {pluralize(
                    `Are you sure you want to ${caption} for ${userIds.length} user[s]?`,
                    userIds.length,
                )}
            </DialogMain>
            <BulkActionFooter
                action="Update"
                onConfirm={async (options?: ActionOptions) => {
                    return await processAction({userIds, browserRegistrationStatus: updateStatus}, options);
                }}>
                <Group>

                    <Button variant="Type.SECONDARY" onClick={() => onCloseModal(false)}>
                        Cancel
                    </Button>
                </Group>
            </BulkActionFooter>
        </>
    );
};
